import { PlansPlanMode } from '../api/types'
import { AllocationPlansListErrorState } from './body/allocation/AllocationPlansListErrorState'
import { LumpsumAllocationBody } from './body/allocation/LumpsumAllocationBody'
import { LumpsumPlansFooter } from './footer/LumpsumPlansFooter'
import {
  LumpsumAllocationHeader,
  resolveAllocationHeaderAppearance
} from './header/allocation/LumpsumAllocationHeader'
import { PlansListChrome } from './header/common/PlansListChrome'
import { LumpsumPlansActionFilters } from './header/common/LumpsumPlansActionFilters'
import {
  isListPlansFetchFailed,
  isListPlansLoading,
  useLumpsumPlansContext
} from './LumpsumPlansProvider'
import { PlansCategoryListSkeleton } from './lumpsum-ui-components/PlansCategoryListSkeleton'
import { AllocationTimerPanel } from './timer/allocation/AllocationTimerPanel'
import { isPlanRolledOut } from './timer/shared/planStatus'

/** Allocation tab: timer/strategy shell vs normal plan slots. */
export function AllocationPageContent() {
  const {
    allocationPlansData,
    allocationPlansQuery,
    refetchAllPlansQueries,
    markTimerResumeRefetch
  } = useLumpsumPlansContext()
  const chromeBackground = resolveAllocationHeaderAppearance(
    allocationPlansData?.riskProfile
  ).chromeBackground

  if (isListPlansLoading(PlansPlanMode.ALLOCATION, allocationPlansQuery)) {
    return (
      <>
        <PlansListChrome background={chromeBackground}>
          <LumpsumAllocationHeader />
        </PlansListChrome>
        <PlansCategoryListSkeleton />
      </>
    )
  }

  if (isListPlansFetchFailed(PlansPlanMode.ALLOCATION, allocationPlansQuery)) {
    return <AllocationPlansListErrorState onRetry={allocationPlansQuery.refetch} />
  }

  if (!isPlanRolledOut(allocationPlansData?.planStatus)) {
    return (
      <AllocationTimerPanel
        planStatus={allocationPlansData?.planStatus}
        timeToPlanDrop={allocationPlansData?.timeToPlanDrop}
        isSubscriptionEligible={allocationPlansData?.isPlanSubscriptionEligible === true}
        strategyCta={allocationPlansData?.strategyCta}
        refetchPlan={() => {
          markTimerResumeRefetch()
          refetchAllPlansQueries()
        }}
      />
    )
  }

  return (
    <>
      <PlansListChrome background={chromeBackground}>
        <LumpsumAllocationHeader />
        <LumpsumPlansActionFilters />
      </PlansListChrome>
      <LumpsumAllocationBody />
      <LumpsumPlansFooter />
    </>
  )
}
